import { ApiEndpoints } from '../../../utils/app-constants';
import { toCondensedDate, toShortDate } from '../../../utils/date-utils';
import {
    DOCUMENT_EXTENSIONS,
    DOCUMENT_REQUEST_LOCATION,
    IDocumentRequest
} from '../../utilities/document-request';
import { API_METHODS } from '../../utilities/type-models';

export class TaxBreakdownReportDocument implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab: boolean = false;
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    public url: string = '';

    constructor(startDate: Date, endDate: Date) {

        const startStr = toShortDate(startDate);
        const endStr = toShortDate(endDate);
        this.url = ApiEndpoints.ACCOUNTING_TAX_BREAKDOWN_REPORT.formattify(startStr, endStr);
        this.filename = `Tax_Breakdown_Report_${toCondensedDate(startDate)}_${toCondensedDate(endDate)}`;
    }
}
